import Column from '@components/Column';
import Header from '@components/Header';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import Complete from './components/Complete';

interface Params {
    cardId: string;
}

const PrepaidCardOrderCompleteActivity: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
    const { cardId } = params;
    const { t } = useTranslation('prepaidCard');
    return (
        <AppScreen>
            <Column>
                <Header noBackIcon title={t('orderComplete.title')} noShadow/>
                <Complete userPrepaidCardId={cardId}/>
            </Column>
        </AppScreen>
    );
};

export default PrepaidCardOrderCompleteActivity;
